module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAAjCAYAAAAe2bNZAAABTElEQVRYR2NkGESAcRC5hWHUMbhiA2vIxM54ZMLA9M+DkZGRmdrR+P///78M/5h2LM6QO4NuNoZjomfdNWViYDnGyMjAQm2HwMz7/5/hzz+GP1ZL05RPI9uB4ZjYWQ9qGBkZm/8z/D/AyMB4gNoO+s/w34GRgdGB8f//2oVpCi14HRM3+2E9AwNDAwgvSpVvpLZj8JmPETKjjoEGP8UhkzDricE/xr/+TP+ZNy5Ik7lAKFppGk2kRuuoY3BF12jI0DRkYLkG3RJYiYqrxEbPZVSJJiRDCOVedHmUkpwqjiE3ZBj+/N+0KFPhPMyFVHEMOWkAm55Rx5ATkhTXTaPVAa5gh+cytFwzINFEaqFD09w0chwzqHoH0bMemTIx/KdDv4nRammaHP5+EygNQDpyzO606lH+Y/i7E70DB7J3tONPUsef1OxKLfWDKpoAjYR7M7Y2F/YAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/order/icon-add.png
// module id = hZR/
// module chunks = 4